import React, { FC } from 'react';
import { Box } from '@src/atoms/Box';
import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';

import styles from './MenuSection.module.scss';

interface IProps extends IDefaultComponentProps {}

export const MenuSection: FC<IProps> = ({ className, style, children }) => {
  const classes = classnames(styles.root, className);

  return (
    <Box className={classes} style={style} paddingTop={12} paddingBottom={12} column>
      {children}
    </Box>
  );
};
